import type { ProductSurface } from '@lib/enums/product-surface.enum'
import type { PasswordResetConfirmInput, PasswordResetRequestInput } from '@lib/input/tenant-auth.input'
import { authService } from '@/services/AuthService'
import { tenantAuthService } from '@/services/TenantAuthService'

/** Whose password a reset page resets: an organization member's (dashboard) or a staff member's (ops console). */
export type PasswordResetAudience = ProductSurface

interface AudienceCopy {
  /** Where to sign in afterwards. */
  loginPath: string
  /** Where to ask for another link. */
  forgotPath: string
  /** "a PixelSign dashboard login", completing "If {email} has …". */
  account: string
  request(input: PasswordResetRequestInput): Promise<void>
  confirm(input: PasswordResetConfirmInput): Promise<void>
}

export const PASSWORD_RESET_AUDIENCES: Record<PasswordResetAudience, AudienceCopy> = {
  dashboard: {
    loginPath: '/login',
    forgotPath: '/forgot-password',
    account: 'a PixelSign dashboard login',
    request: (input) => tenantAuthService.requestPasswordReset(input),
    confirm: (input) => tenantAuthService.confirmPasswordReset(input),
  },
  ops: {
    loginPath: '/ops/login',
    forgotPath: '/ops/forgot-password',
    account: 'a PixelSign staff account',
    request: (input) => authService.requestPasswordReset(input),
    confirm: (input) => authService.confirmPasswordReset(input),
  },
}
